import { BaseHook, BaseHooks } from '@/types'

class Hooks<T> implements BaseHooks<T> {
  private hooks: BaseHook<T>[] = []

  register(hook: BaseHook<T>): void {
    this.hooks.push(hook)
  }

  execute(value: T): void {
    this.hooks.forEach(async (hook) => {
      try {
        await hook(value)
      }
      catch (error: any) {
        // eslint-disable-next-line no-console
        console.error('Error during hook call:', error)
      }
    })
  }
}

export function createHooks<T>(): BaseHooks<T> {
  return new Hooks<T>()
}